import React, { useState, useEffect, useContext } from 'react'
import { Table, Button, Form } from 'react-bootstrap'
import "./Company.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faBuilding, faStore, faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { listCompany, removeCompany } from '../Network/Company'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import { Container, Loading, TablePagination, HeaderTitle, AlertBar } from '../Library'
import { useHistory } from 'react-router-dom'
import { setDocumentTitle } from '../AppTitle'
import { RoleContext } from '../Role/RoleContext'
import { AlertModalContext } from '../Library/AlertModalContext'

function Company() {
    const history = useHistory()
    const alertModal = useContext(AlertModalContext)
    const roleCx = useContext(RoleContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.company
    const notifyCx = useContext(NotifyContext)
    const [isLoading, setLoading] = useState(false)
    const [companyList, setCompanylist] = useState([])
    const [searchComapiesList, setSearchCompaniesList] = useState([])
    const [isSearching, setSearching] = useState(false)
    const [searchKeyword, setSearchKeyword] = useState("")

    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 10
    const totalPage = Math.ceil(companyList.length / perPage)
    const indexOfLast = currentPage * perPage
    const indexOfFirst = indexOfLast - perPage

    const fetchList = () =>{
        setLoading(true)
        listCompany(
            (data)=>{
                setCompanylist(data)
                setLoading(false)
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            }
        )
    }

    const deleteCompany = (id) =>{
        alertModal.setTitle(lang.delete_company)
        alertModal.setDescription(lang.delete_sure)
        alertModal.setAlertType("EXTREME")
        alertModal.setButton([
            {
                title: langCx.lang.confirm.ok,
                variant: "danger",
                onClick: ()=>{ 
                    alertModal.setIsShow(false)
                    setLoading(true)
                    removeCompany(id,
                        ()=>{
                            notifyCx.showNotify(lang.deleted_company, lang.deleted_company_desc, 0)
                            fetchList();
                        },
                        (error)=>{
                            setLoading(false)
                            notifyCx.showNotify("Something wrong", error.message, 2)
                        })
                }
            },
            {
                title: langCx.lang.confirm.cancel,
                variant: "secondary",
                onClick: ()=>{ 
                    alertModal.setIsShow(false) 
                }
            }
        ])
        alertModal.setIsShow(true)
        // if(window.confirm(lang.delete_sure)){
        //     setLoading(true)
        //     removeCompany(id,
        //         ()=>{
        //             notifyCx.showNotify(lang.deleted_company, lang.deleted_company_desc, 0)
        //             fetchList();
        //         },
        //         (error)=>{
        //             setLoading(false)
        //             notifyCx.showNotify("Something wrong", error.message, 2)
        //         })
        // }
    }

    const onSearch = (e) =>{
        setSearchKeyword(e.target.value)
        let text = e.target.value.toLowerCase()

        if(text.length > 0){
            setSearching(true)
            var result = companyList.filter((el)=>el.name.toLowerCase().includes(text))
            setSearchCompaniesList(result)
        }else{
            setSearching(false)
        }
    }

    const isMaximumCompany = () =>{
        let limitCompany = localStorage.getItem("limit_tenants")
        let limitCompanyInt = parseInt(limitCompany)
        if(companyList.length >= limitCompanyInt && limitCompanyInt !== 0){
            return true
        }else{
            return false
        }
    }

    useEffect(()=>{
        const fetchList = () =>{
            setLoading(true)
            listCompany(
                (data)=>{
                    setCompanylist(data)
                    setLoading(false)
                },
                (error)=>{
                    notifyCx.showNotify("Something wrong", error.message, 2)
                    setLoading(false)
                }
            )
        }
        setDocumentTitle("Company")
        fetchList()
    },[notifyCx])

    return (
        <Container topbarTitle={langCx.lang.sidebar.company}>
        { isLoading ? <Loading/> : null }
        <div id="company">
            <HeaderTitle title={lang.list_company}
            customRight={
                <Form.Control
                placeholder={lang.search_company}
                onChange={onSearch}
                value={searchKeyword}
                type="search"
                />
            }
            />
            { isMaximumCompany() ? 
            <AlertBar title={lang.meet_limit_tenant} style={{ marginBottom: 10 }}/>
            : null
            }
            <div className="button-container">
                { roleCx.checkPermission("_MENU_", "app.company_add") ?
                <Button
                disabled={isMaximumCompany()}
                onClick={()=>history.push("/company/add")}
                >
                    {lang.add_new_company}
                </Button>
                : null
                }
            </div>
            { isSearching ?
            <div className="search-bar-indicator">
                <b>{searchComapiesList.length}</b>{" " + lang.company_found}
                <a href="#"
                style={{ marginLeft: 5 }}
                onClick={(e)=>{
                    e.preventDefault()
                    setSearchKeyword("")
                    setSearching(false)
                }}>
                    {lang.clear_search}
                </a>
            </div>
            : null
            }
            <div className="table-container">
                <Table 
                className="table-company"
                hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.company_name}</th>
                            <th>{lang.company_name_en}</th>
                            <th>{lang.acronym}</th>
                            <th>{lang.location}</th>
                            <th>{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { !isSearching ?
                        <>
                        { companyList.slice(indexOfFirst, indexOfLast).map((item, key)=>
                            <CompanyRow
                            key={key}
                            companyname={item.name}
                            companynameEn={item.nameEn}
                            type={item.type}
                            acronym={item.acronym}
                            location={item.location}
                            onClick={()=>history.push("/company/detail/"+item.id)}
                            onClickDelete={()=>deleteCompany(item.id)}
                            />
                        )}
                        { companyList.length === 0 ?
                        <tr style={{textAlign: 'center'}}>
                            <td colSpan={6}>{lang.no_company}</td>
                        </tr>
                        : null
                        }
                        </>
                        : 
                        <>
                        { searchComapiesList.map((item, key)=>
                            <CompanyRow
                            key={key}
                            companyname={item.name}
                            companynameEn={item.nameEn}
                            type={item.type}
                            acronym={item.acronym}
                            location={item.location}
                            onClick={()=>history.push("/company/detail/"+item.id)}
                            onClickDelete={()=>deleteCompany(item.id)}
                            />
                        )}
                        { searchComapiesList.length === 0 ?
                        <tr style={{textAlign: 'center'}}>
                            <td colSpan={5}>{lang.no_company_found}</td>
                        </tr>
                        : null}
                        </>
                        }
                    </tbody>
                </Table>
            </div>
            { !isSearching ?
            <div className="pagination">
                <TablePagination
                dataLength={totalPage}
                size={10}
                currentPage={currentPage}
                handlerPaginationClick={(page)=>{ setCurrentPage(page) }}
                nextClick={()=>{ setCurrentPage(currentPage + 1) }}
                prevClick={()=>{ setCurrentPage(currentPage - 1) }}
                firstPageClick={(first)=>{ setCurrentPage(first) }}
                lastPageClick={(last)=>{ setCurrentPage(last) }}
                disabledPrev={currentPage === indexOfFirst + 1}
                disabledNext={currentPage === totalPage}
                />
            </div>
            : null
            }
        </div>
        </Container>
    )
}

function CompanyRow(props){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.company
    let typeIcon = { icon: faQuestionCircle, color: 'gray' }
    
    switch(props.type){
        case("OFFICE"):
            typeIcon = { icon: faBuilding, color: 'green' }
            break
        case("RETAIL"):
            typeIcon = { icon: faStore, color: 'orange' }
            break
    }

    return(
        <tr className="company-row"
        >
            <td className="icon">
                <FontAwesomeIcon icon={typeIcon.icon} color={typeIcon.color}/>
            </td>
            <td>{props.companyname}</td>
            <td>{props.companynameEn || '-'}</td>
            <td>{props.acronym}</td>
            <td>{props.location}</td>
            <td style={{width: 180}}>
                <Button size="sm" style={{marginRight: 5}}
                onClick={props.onClick}
                >{lang.detail}</Button>
                <Button size="sm" variant="danger"
                onClick={props.onClickDelete}>
                    <FontAwesomeIcon icon={faTrash}/>
                </Button>
            </td>
        </tr>
    )
}

export default Company
